import DataObjectField from "@/utilities/classes/data-object-field";

const buildProjectTeamObject = (vData, recordId) => {
    const fields = [
        new DataObjectField(recordId, 15),
        new DataObjectField(vData.Role, 19),
        new DataObjectField(vData.CompanyName, 23),
        new DataObjectField(vData.StateOfEntity, 25),
        new DataObjectField(vData.Address.Street1, 28),
        new DataObjectField(vData.Address.Street2, 29),
        new DataObjectField(vData.Address.City, 30),
        new DataObjectField(vData.Address.State, 31),
        new DataObjectField(vData.Address.Zip, 32),
        new DataObjectField(vData.Address.Country, 33),
        new DataObjectField(vData.Contact.Name, 21),
        new DataObjectField(vData.Contact.Email, 36),
        new DataObjectField(vData.Contact.Phone, 34),
    ];

  const dataObject = {
    qdbapi: {
      udata: "SHARC_CREATE_TEAM",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      clist: "3",
      field: fields
    }
  };
  return dataObject;
};

export default buildProjectTeamObject;